<template>
  <button
    class="card"
    @click="$emit('click')"
    @keyup.enter="$emit('click')"
  >
    <div class="card__wrap">
      <div
        v-if="imgUrl"
        class="card__imageWrap"
      >
        <img
          :src="imgUrl"
          class="card__image"
          width="350"
          height="420"
          loading="lazy"
          alt=""
        >
      </div>
      <div class="card__content pt-double pb-single">
        <h3
          v-if="title"
          class="card__title"
        >
          {{ title }}
        </h3>
        <span
          v-if="badge"
          class="card__badgeWrap"
        >
          <Badge
            :label="badgeLabel"
            :text="badge"
          />
        </span>
        <p
          v-if="summary"
          class="card__summary"
        >
          {{ summary }}
        </p>
        <slot />
      </div>
    </div>
  </button>
</template>

<script>

export default {
  name: 'Card',
  props: {
    image: {
      type: [String],
      required: false,
      default () {
        return ''
      },
    },
    title: {
      type: [String, Number],
      required: false,
      default () {
        return undefined
      },
    },
    summary: {
      type: [String, Number],
      required: false,
      default () {
        return undefined
      },
    },
    badge: {
      type: [String, Number],
      required: false,
      default () {
        return undefined
      },
    },
    badgeLabel: {
      type: [String, Number],
      required: false,
      default () {
        return undefined
      },
    },
  },
  computed: {
    imgUrl () {
      return this.image || process.env.VUE_APP_EMBED_URL + 'img/candidate-placeholder.jpg'
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
